import React from 'react'
import ReactTable from '@norkart/react-table'

import { datoFormatMedBareAar } from '../../../felles/utils/dato-format-tabell'

import './maalerliste.css'

const columns = [
    {
      id: 'Maaleradresse',
      name: 'Adresse',
      sortParams: ['Maaleradresse'],
      sortable: true,        
      isSorted: false,
      formatter: function (maaler) {
        return maaler.Maaleradresse + ' ' + maaler.Husnummer + ' ' + (maaler.Husbokstav ? maaler.Husbokstav : '')
      }
    },
    {
      id: 'Maalernummer',
      name: 'Målernummer',
      sortable: false,
      isSorted: false
    },
    {
      id: 'Installasjonsdato',
      name: 'Installert',
      sortParams: 'Installasjonsdato',
      sortable: true,
      filterable: true,
      isSorted: false,
      formatter: function (item) {
        return datoFormatMedBareAar(item.Installasjonsdato)
      }
    },
    {
      id: 'Status',
      name: 'Status',
      sortParams: 'Status',
      sortable: true,       
      isSorted: false
    },
    {
      id: 'Sone',
      name: 'Sone',
      sortParams: 'Sone',
      sortable: true,      
      isSorted: false
    },
    {
      id: 'Avtaletype',
      name: 'Avtaletype',
      sortParams: 'Avtaletype',
      sortable: true,
      isSorted: false
    },
    {
      id: 'Vannprosent',
      name: 'Vann%',
      sortable: false,
      isSorted: false
    },
    {
      id: 'Avlopprosent',
      name: 'Avløp%',
      sortable: false,
      isSorted: false
    },
    {
      id: 'Avtalenummer',
      name: 'Avtalenummer',
      sortable: false,
      isSorted: false
    }     
  ];

const Maalerliste = ({ onVannmaalereValgt, valgteMaalere, vannmaalere }) =>
  <div className="vm-maalerliste">
      <h2 className="header">Vannmålere ({vannmaalere != null ? vannmaalere.length : 0})</h2>      
      <ReactTable
          items={vannmaalere}
          idProperty='Id'
          showIndex={false}
          filterable={false}
          itemsPrPage={15}
          columns={columns}
          selectableRows={true}
          onRowClick={() => {}}
          selection={valgteMaalere}
          onRowSelectionChange={onVannmaalereValgt}
      />
  </div>

export default Maalerliste


// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/rediger/maalerliste.jsx